// test1578
(1578 && 0);
